function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5803 43.7059C13.3217 45.8804 14.9066 48.171 16.3235 50.5611C17.5333 52.8089 18.0377 54.3331 18.9218 57.0415C19.464 58.5378 19.9541 58.9844 21.0077 58.9844C22.1558 58.9844 22.6767 58.2247 23.0791 57.0497C23.9149 54.4919 24.5706 52.5399 25.6052 50.6955C27.6353 47.1346 30.1579 43.9703 32.6366 40.9292C33.3076 40.0684 37.6461 35.0541 39.5992 31.0975C39.5992 31.0975 41.9998 26.7513 41.9998 20.6814C41.9998 15.0036 39.6324 11.0657 39.6324 11.0657L32.8164 12.8543L28.6771 23.5372L27.653 25.0103L27.4483 25.2771L27.1759 25.6112L26.6979 26.1448L26.0147 26.814L22.3287 29.7566L13.1133 34.9705L11.5803 43.7059Z",
  fill: "#34A853"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.06909 30.3668C4.31822 35.4008 8.65538 39.8259 11.5898 43.7093L27.1759 25.618C27.1759 25.618 24.9801 28.432 20.997 28.432C16.5602 28.432 12.976 24.9603 12.976 20.5827C12.976 17.5808 14.819 15.5186 14.819 15.5186L4.23882 18.2965L2.06909 30.3666V30.3668Z",
  fill: "#FBBC04"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.35 0.930337C32.5265 2.56578 36.9571 5.99919 39.6371 11.0621L27.1807 25.6076C27.1807 25.6076 29.0237 23.508 29.0237 20.5248C29.0237 16.0453 25.1743 12.6988 21.0159 12.6988C17.0834 12.6988 14.825 15.5082 14.825 15.5082V6.34467L27.35 0.930176V0.930337Z",
  fill: "#4285F4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.92432 7.35732C8.01607 3.73259 13.4564 0 20.9567 0C24.5956 0 27.3371 0.936123 27.3371 0.936123L14.8132 15.5162H5.93986L4.92432 7.35748V7.35732Z",
  fill: "#1A73E8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2.06916 30.3667C2.06916 30.3667 0 26.3962 0 20.6441C0 15.2076 2.15677 10.4554 4.92434 7.35718L14.8203 15.5173L2.06916 30.3667Z",
  fill: "#EA4335"
});

function SvgGooglemaps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 59,
    viewBox: "0 0 42 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglemaps);
export default __webpack_public_path__ + "static/media/googlemaps.c515d39d.svg";
export { ForwardRef as ReactComponent };